import MyService from './MyService';

import apiService from '../ApiService';

export default new MyService(apiService);
